import { render, staticRenderFns } from "./LeccionF4.vue?vue&type=template&id=bf194952&"
import script from "./LeccionF4.vue?vue&type=script&lang=js&"
export * from "./LeccionF4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports